// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8e6b54ce72efef1df45631d3ca85bab6c5eb0646.chunk.bundle.js";
};